import React from "react";
import CtaSection from "../../components/Common/CtaSection";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import shapeImageUrl from "../../assets/images/shapes/cta-one-shape-1.png";

const VisualizerMain = () => {
    return (
        <React.Fragment>
            <section className="visualizer-coming-soon">
                <div className="container">
                    <div className="visualizer-coming-soon__inner">
                        <div className="visualizer-coming-soon__art" aria-hidden="true">
                            <div className="visualizer-coming-soon__sun" />
                            <div className="visualizer-coming-soon__line visualizer-coming-soon__line--one" />
                            <div className="visualizer-coming-soon__line visualizer-coming-soon__line--two" />
                            <div className="visualizer-coming-soon__building">
                                <div className="visualizer-coming-soon__shaft">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                                <div className="visualizer-coming-soon__lift">
                                    <div className="visualizer-coming-soon__lift-door visualizer-coming-soon__lift-door--left" />
                                    <div className="visualizer-coming-soon__lift-door visualizer-coming-soon__lift-door--right" />
                                    <div className="visualizer-coming-soon__lift-light" />
                                </div>
                            </div>
                            <div className="visualizer-coming-soon__floor" />
                        </div>
                        <div className="visualizer-coming-soon__content">
                            <span className="visualizer-coming-soon__eyebrow">Arch Elevators</span>
                            <h2>Our visualizer is on its way</h2>
                            <p>
                                Explore finishes, cabin styles, and vertical mobility solutions in a new interactive experience.
                            </p>
                            <span className="visualizer-coming-soon__status">Coming soon</span>
                            <br /><br /><br /><br /><br /><br />
                        </div>
                    </div>
                </div>
            </section>
            <CtaSection
                breadcrumbsImg={bannerbg}
                shapeImageUrl={shapeImageUrl}
                title="Need any help? contact us!"
                text="Need help?"
                phoneNumber="+91 90332 26011"
            />
        </React.Fragment>
    )
}

export default VisualizerMain;